export const FETCH_THERMIT_DATA_WITHOUT_MAX_MIN_REQUEST = 'FETCH_THERMIT_DATA_WITHOUT_MAX_MIN_REQUEST'
export const FETCH_THERMIT_DATA_WITHOUT_MAX_MIN_SUCCESS = 'FETCH_THERMIT_DATA_WITHOUT_MAX_MIN_SUCCESS'
export const FETCH_THERMIT_DATA_WITHOUT_MAX_MIN_FALUIRE = 'FETCH_THERMIT_DATA_WITHOUT_MAX_MIN_FALUIRE'
export const FETCH_THERMIT_FORMATTED_UNIT_DATA_WITHOUT_MAX_MIN_DATA = 'FETCH_THERMIT_FORMATTED_UNIT_DATA_WITHOUT_MAX_MIN_DATA'
